var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"appendToBody":false,"title":_vm.$lang('查看操作记录'),"size":"large_large","customClass":"mw-form-view-dialog"}},[_c('div',{staticClass:"mw-margin-top-10 process-dialog"},[_c('mw-table',{attrs:{"api":_vm.api,"columns":_vm.columns,"pagination":false,"nowrap":false,"defaultParams":_vm.defaultParams,"defaultParamsAutoLoad":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-179435bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/public-dialog/process-operationRecord.vue
// module id = 1157
// module chunks = 0 1